import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { SuggestedPersonalLoanOffersView } from './SuggestedPersonalLoanOffersView';
import React from 'react';
import { useLinkHandler } from 'hook/event.hook';

const SuggestedPersonalLoanOffers = props => {
  const onLinkClickCallback = useLinkHandler(props.eventHandler);
  return (
    <SectionContainer>
      <SuggestedPersonalLoanOffersView
        personalLoans={props.offers}
        onLinkClickCallback={onLinkClickCallback}
        {...props}
      />
    </SectionContainer>
  );
};

export default SuggestedPersonalLoanOffers;
